// plop_marker:layouts_import
import DevelopersAppsMenuStatic from "./developers-apps-menu-static/index.js";
export default {
    // plop_marker:layouts_add_layout
    DevelopersAppsMenuStatic
};
